import React from 'react';
import { Modal } from '../ui/Modal';
import { INSPECTION_STAGES, INSPECTION_ITEMS } from '@skd/shared';

interface DefectEntry {
  stageId: number;
  itemId: string;
  defectType: string;
  remark: string;
  inspectorFure: string;
  dateTime: string;
}

interface NGDefectsModalProps {
  isOpen: boolean;
  onClose: () => void;
  defects: DefectEntry[];
  bodyNumber: string;
}

export function NGDefectsModal({ isOpen, onClose, defects, bodyNumber }: NGDefectsModalProps) {
  const getItemLabel = (itemId: string) => {
    const item = INSPECTION_ITEMS.find((i) => i.id === itemId);
    return item ? `${item.code} - ${item.label}` : itemId;
  };

  const getStageName = (stageId: number) => {
    const stage = INSPECTION_STAGES.find((s) => s.id === stageId);
    return stage ? stage.shortName : `Section ${stageId}`;
  };

  return (
    <Modal id="ng-defects" isOpen={isOpen} onClose={onClose} title={`NG Defects - ${bodyNumber}`} size="lg">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-[var(--border-color)] text-left">
              <th className="p-2 font-semibold text-[var(--text-muted)]">Section</th>
              <th className="p-2 font-semibold text-[var(--text-muted)]">Component</th>
              <th className="p-2 font-semibold text-[var(--text-muted)]">Defect Type</th>
              <th className="p-2 font-semibold text-[var(--text-muted)]">Remark</th>
              <th className="p-2 font-semibold text-[var(--text-muted)]">Inspector</th>
              <th className="p-2 font-semibold text-[var(--text-muted)]">Timestamp</th>
            </tr>
          </thead>
          <tbody>
            {defects.length === 0 ? (
              <tr>
                <td colSpan={6} className="p-6 text-center text-[var(--text-dim)]">
                  No defects found for this record.
                </td>
              </tr>
            ) : (
              defects.map((d, i) => (
                <tr key={i} className="border-b border-[var(--border-color)]">
                  <td className="p-2 text-xs font-bold">{getStageName(d.stageId)}</td>
                  <td className="p-2 text-xs font-mono">{getItemLabel(d.itemId)}</td>
                  <td className="p-2">
                    <span className="badge badge-danger text-[10px]">{d.defectType}</span>
                  </td>
                  <td className="p-2 text-xs text-[var(--text-muted)]">{d.remark || '-'}</td>
                  <td className="p-2 text-xs">{d.inspectorFure || '-'}</td>
                  <td className="p-2 text-xs font-mono text-[var(--text-dim)]">{d.dateTime || '-'}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <div className="flex justify-end mt-4 pt-4 border-t border-[var(--border-color)]">
        <button className="btn btn-secondary" onClick={onClose}>Close</button>
      </div>
    </Modal>
  );
}
